import * as React from 'react';
import {useState} from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import {PanelContext} from 'react-popup-context';
import {date} from 'ka-erp-data';
import {List} from '../common/btns';
import OrderDetail from './order-detail';
import MemberEditor from './member-editor';
import OrderItem from './main/order';
import * as User from '../lib/user';

const css = require('./main.css').default;
const headerCss = require('../common/header.css').default;

export default function({ctx, dealer, orders}: {
    ctx: PanelContext,
    dealer: string,
    orders: order[] | null,
}) {
    const [showMenu, setShowMenu] = useState(false);

    function editUser() {
        setShowMenu(false);
        ctx.popup(<MemberEditor dealer={dealer} ctx={ctx}/>);
    }

    function gotoDetail(order: order) {
        ctx.popup(<OrderDetail
            order={order}
            onDone={() => ctx.close()}/>);
    }

    return (
    <>
        <div id={headerCss.header}>
            <List width={25} height={25} onClick={() => setShowMenu(true)}/>
            <div>最近 7 天的訂單</div>
        </div>
        <div id={css.main}>
            <div>
                {(() => {
                    if (orders === null) {
                        return (
                        <div style={{display: 'flex', justifyContent: 'center'}}>
                            <img src='imgs/loading.gif' style={{height: '100px'}}/>
                        </div>);
                    } else {
                        if (orders.length === 0) {
                            return (
                            <div style={{textAlign: 'center', fontSize: '1.3em', color: 'lightgray', marginTop: '1em'}}>
                                無資料
                            </div>)
                        } else {
                            return orders
                            .map(ord => 
                                <OrderItem key={ord.id}
                                    order={ord}
                                    onClick={gotoDetail}
                                />);
                        }
                    }
                })()}
            </div>
        </div>
        <Offcanvas show={showMenu} onHide={() => setShowMenu(false)}>
            <Offcanvas.Header closeButton>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div id={css.menu}>
                    <div onClick={editUser}>權限設定</div>
                    <div onClick={() => {
                        User.clear();
                        window.location.reload();
                    }}>登出</div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    </>);
}

type order = {
    id: string,
    _id: number,
    createDate: date,           // 建立日期
    billDate: date,
    deliverDate: date | null,   // 預計出貨日
    receiverId: string | null,
    receiverName: string | null,
    address: string,
    memo: string | null,
    outOfStock: boolean,
    pkgs: pkg[] | 'loading',
    items: {
        _id: number,
        seq: number,
        product: {
            id: string,
            name: string,
        } | 'loading',
        qty: number,
        classCnt: number,
        giftQty: number | null,
        memo: string | null,
    }[],
}

type pkg = {
    order: string,
    logistic: string,
    items: {
        packDate: date | null,
    }[],
}
